import { Component } from '@angular/core';
import { BeerServiceProvider } from "../../providers/beer-service/beer-service";
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from "../../providers/user-data/user-data";
import { /*Analysis,*/ RequestUser /*, WishlistAdd, WishlistRemove, WishlistGet, BeerProfileRequest, SearchRequest*/ } from "../../models/models"
import { ModalController } from '@ionic/angular'
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysesPage_PATH } from '../../app/app-constants';

/**
 * Generated class for the StatBarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'stat-bar',
  templateUrl: 'stat-bar.html',
  styleUrls: ['./stat-bar.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class StatBarComponent {
  public beerCount: string;
  public breweryCount: string;
  public analysisCount: number;

  constructor(
    private beerService: BeerServiceProvider,
    private locationService: LocationServiceProvider,
    private router: Router,
    private viewController: ModalController,
    private userDataProvider: UserDataProvider
  ) {
    //TODO : move auth to service
    userDataProvider.getUserID().then((userId) => {
      let user = new RequestUser(userId, locationService.latitude, locationService.longitude);

      this.beerService.getStats(user).subscribe((resp: any) => {
        //console.log("Resp for stats: " + resp)
        this.beerCount = this.formatThousands(resp.beercount);
        this.breweryCount = this.formatThousands(resp.brewerycount);
        this.analysisCount = resp.myanalysescount;
      }, err => console.log(err));
    
    })
  }

  showMyAnalyses() {
        //go to the "My analyses" page
        //console.log("go to my analyses");
        //this.navController.setRoot(AnalysesPage);
        this.router.navigate([ AnalysesPage_PATH])
      }

  formatThousands(input: number) : string {
/*
        if(input <1000)
      return input + "";
        else {
          let thousands = Math.floor(input / 1000);
          let modulo = input % 1000;
          return thousands + "." + modulo;
        }
*/
    return input.toLocaleString('nl-NL');
      }

}
